"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("stremio/common/Button"));
var useBinaryState_1 = __importDefault(require("stremio/common/useBinaryState"));
var Dropdown_1 = __importDefault(require("./Dropdown"));
var classnames_1 = __importDefault(require("classnames"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var MultiselectMenu_less_1 = __importDefault(require("./MultiselectMenu.less"));
var useOutsideClick_1 = __importDefault(require("stremio/common/useOutsideClick"));
var MultiselectMenu = function (_a) {
    var _b, _c;
    var className = _a.className, title = _a.title, options = _a.options, selectedOption = _a.selectedOption, onSelect = _a.onSelect;
    var _d = (0, useBinaryState_1.default)(false), menuOpen = _d[0], closeMenu = _d[2], toggleMenu = _d[3];
    var multiselectMenuRef = (0, useOutsideClick_1.default)(function () { return closeMenu(); });
    var _e = react_1.default.useState(0), level = _e[0], setLevel = _e[1];
    var onOptionSelect = function (value) {
        level ? setLevel(level + 1) : onSelect(value), closeMenu();
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(MultiselectMenu_less_1.default['multiselect-menu'], className), ref: multiselectMenuRef },
        react_1.default.createElement(Button_1.default, { className: (0, classnames_1.default)(MultiselectMenu_less_1.default['multiselect-button'], (_b = {}, _b[MultiselectMenu_less_1.default['open']] = menuOpen, _b)), onClick: toggleMenu, tabIndex: 0, "aria-haspopup": 'listbox', "aria-expanded": menuOpen },
            title,
            react_1.default.createElement(react_2.default, { name: 'caret-down', className: (0, classnames_1.default)(MultiselectMenu_less_1.default['icon'], (_c = {}, _c[MultiselectMenu_less_1.default['open']] = menuOpen, _c)) })),
        menuOpen ?
            react_1.default.createElement(Dropdown_1.default, { level: level, setLevel: setLevel, options: options, onSelect: onOptionSelect, menuOpen: menuOpen, selectedOption: selectedOption })
            : null));
};
exports.default = MultiselectMenu;
